import React, { useCallback, useEffect, useRef, useState } from "react";
import { getOverallSettingsClasses, getOverallSettingsStyles, loadGMap } from "../../utils/siteUtils";
import { BodyText, FilterDelarDropdown, DelarDropdown, Heading, Icon, PrimaryButton, BackgroundImage } from "../../elements";
import { apiAsia } from "../../utils/api-asia";
import { getApiError } from "../../services/siteService";
import { formatString } from "../../utils";
import classNames from "classnames";
import "./style.scss";
import { MAP_BLACK_STYLE } from "../../utils/constants";
import * as ReactDOM from "react-dom";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import store from "../../redux/store/store";
import { Provider } from "react-redux";
import { mobileIs } from "../../utils/siteUtils";
import { gtag } from "../../utils";
let maps = null;
let map = null;
let currentPos = null;
let visibleOverlay = null;
const DealerSearch = props => {
  const { fields, page } = props;
  const { title, country_label, city_label, result_text, test_drive_text, buy_text, result_empty_text, empty_image, go_text, sales_type, sale_label, m_market_icon, market_icon, new_text, comeing_soon_text, test_drive_link, countryError, language } = fields;
  const [countryOptions, setCountryOptions] = useState([]);
  const [countrySelected, setCountrySelected] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [citySelected, setCitySelected] = useState(null);
  const [cityError, setCityError] = useState(null);
  const [result, setResult] = useState([]);
  const [allresult, setAllresult] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [resultTitle, setResultTitle] = useState(null);
  const [showEmpty, setShowEmpty] = useState(false);
  const [getPosition, setGetPosition] = useState(false);
  const [unSelected, setUnSelected] = useState(false);
  const [country, setCountry] = useState(null);
  const [zoom, setZoom] = useState(15);
  const [driveType, setDriveType] = useState(null);
  const [count, setCount] = useState(0);
  const [shwoFirst, setShwoFirst] = useState(true);
  const [allCount, setAllCount] = useState(0);
  const [startX, setStartX] = useState(null);
  const [countryShowError, setCountryShowError] = useState(false);
  const swiper = useRef(null);
  const swiperEl = useRef(null);
  const allswiper = useRef(null);
  const allswiperEl = useRef(null);
  const mapNode = useRef(null);

  const isAR = page?.fields?.rtl?.value;
  let lang = language?.fields?.phrase?.value ? language?.fields?.phrase?.value : 'en';
  const resultRef = useRef([]);
  const isMobile = mobileIs()
  const maxZoom = 16;
  const minZoom = 3;
  const initMap = async e => {
    const mapOptions = {
      mapTypeId: maps.MapTypeId.ROADMAP, //地图类型（地图、地形图、卫星图 三种可选）
      disableDefaultUI: false, //是否彻底停用默认用户界面
      zoomControl: false, //是否显示右下角放大、缩小按钮
      mapTypeControl: false, //是否显示左上角地图类型选择框
      scaleControl: false, //是否右下角显示地图比例尺
      zoom, //地图缩放级别（放大、缩小也是修改此选项
      maxZoom,
      minZoom,
      fullscreenControl: false, // 右上角全屏
      styles: MAP_BLACK_STYLE
    };
    if (e?.coords) {
      console.log('e.coords===>', e.coords)
      currentPos = e.coords;
      mapOptions.center = new maps.LatLng(e.coords.latitude, e.coords.longitude);
    }
    map = new maps.Map(mapNode.current, mapOptions);
  };
	const init = async () => {
		getCountry()
	};
  const getCountry = async () => {
    apiAsia.form.country({language: lang}).then(res => {
			console.log(res[0])
      if (!!res[0]) {
        let countrtList = []
        res[0].forEach(v=>{
          countrtList.push({
            code : v.countryCode,
            value : v.countryName
          })
        })
        setCountryOptions(countrtList);
        getCountryCode(countrtList)
        if(countrtList.length>0){
          // setCountrySelected(countrtList[0]); //默认选中国家列表中第一个
          // getCities(countrtList[0])
        }
      }
    })
    .catch(err => {
      // 
    });
  };
  const initComponent = async _maps => {
    if (mapNode.current) {
      maps = _maps;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          e => {
            setGetPosition(true) // 用户允许获取定位信息
            initMap(e).catch();
          },
          ex => {
            setGetPosition(false) // 用户拒绝获取定位信息
            console.error(ex);
            initMap().catch();
          }
        );
      } else {
        initMap().catch();
      }
    }
  };
  const getCities = async country => {
    let params = {
      language: lang,
      countryCode: country.code,
      regionCode: null
    }
    apiAsia.form.city(params).then(res => {
      if (!!res[0]) {
        let data = res[0].map(v=>{
          v.code = v.cityCode
          v.value = v.cityName
          return v
        })
        setCityOptions(data);
        setCitySelected(data[0]);
        if(data[0]) search(country, data[0], driveType);
      }else{
        setCityOptions([]);
      }
    })
    .catch(err => {
      setCityError(err);
      setCityOptions([]);
    });
  };
  const search = async (country, city, driveType, type) => {
    setActiveIndex(null)
    if (visibleOverlay) {
      visibleOverlay.hide();
    }
    setAllCount(0)
    setAllresult([]);
    setCount(0)
    setCountry(country)
    setResult([]);
    resultRef.current = [];
    const body = {
      language: lang,
      regionCode: null,
      cityCode: city?.cityCode,
      countryCode: country?.code,
      driveType: driveType !== undefined ? driveType?.fields?.key?.value : ''
    };
    if (currentPos) {
      Object.assign(body, {
        latitude: currentPos.latitude,
        longitude: currentPos.longitude
      });
    }
    const [res, ex] = await apiAsia.form.dealer(body);
    if (ex) {
      const error = await getApiError(ex.code);
      setCityError(error);
      return;
    }
    if(res.length < 1) {
      search(null, null, driveType, 1)
      setShowEmpty(true)
      return false 
    }
    res.forEach((item, index) => {
      const marker = (item.marker = new maps.Marker({
        position: new maps.LatLng(item.latitude, item.longitude),
        map: map,
        icon: isMobile ? m_market_icon?.value?.src : market_icon?.value?.src,
        // animation: maps.Animation.DROP,
        title: item.name
      }));
      marker.addListener("click", e => {
        if(isMobile) {
          setCount(index)
        }
        setActiveIndex(index);
        if (visibleOverlay) {
          visibleOverlay.hide();
        }
        visibleOverlay = item.overlay;
        item.overlay.show();
      });
      if (currentPos) {
        let distance = null
        if(item.latitude && item.longitude) {
          distance = getDistance(currentPos, {
            latitude: item.latitude,
            longitude: item.longitude
          });
          item.distanceNum = distance;
          item.distance = `${distance.toFixed(2)}km`;
        } else {
          item.distance = null
        }
      }
      // res[0].active = true;
      // setActiveIndex(0);
      // setShwoFirst(true)
      // let timer = setTimeout(() => {
      //   if(shwoFirst) {
      //     visibleOverlay = res[0].overlay;
      //     res[0].overlay.show();
      //     clearTimeout(timer)
      //     setShwoFirst(false)
      //   }
      // }, 100);
      const contentDiv = document.createElement("div");
      contentDiv.classList.add("marker-overlay");
      ReactDOM.render(
        <Provider store={store}>
          <DealerOverlay {...{ item, go_text, test_drive_link, test_drive_text, buy_text }} />
          <Animate />
        </Provider>,
        contentDiv
      );
      item.overlay = addPopup(new maps.LatLng(item.latitude, item.longitude), contentDiv);
      item.overlay.setMap(map);
      item.overlay.hide();
    });
		if(map) {
			map.setCenter(new maps.LatLng(res[0].latitude, res[0].longitude));
		}
    
    if(type === 1) {
      setAllresult(res);
    } else {
      setResult(res);
    }
    
    setResultTitle(
      formatString(result_text.value, {
        count: res.length,
        keyword: city?.value
      })
    );
  };
  const getDistance = (start, end) => {
    const lat1 = (Math.PI / 180) * start.latitude;
    const lng1 = (Math.PI / 180) * start.longitude;
    const lat2 = (Math.PI / 180) * end.latitude;
    const lng2 = (Math.PI / 180) * end.longitude;
    const a = lat1 - lat2;
    const b = lng1 - lng2;
    const r = 6378137;
    const s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(b / 2), 2))) * r;
    return Number((s / 1000).toFixed(2));
  };
  const getItemBtn = (text, href) => {
    return {
      colorScheme: {
        fields: {
          phrase: {
            value: "outline-green"
          }
        }
      },
      iconDef: "Right",
      link: { value: { text, href, target: "_blank" } }
    };
  };
  const addPopup = (position, content) => {
    class Popup extends maps.OverlayView {
      position;
      div;
      constructor(position, content) {
        super();
        this.position = position;
        content.classList.add("popup-bubble");

        this.div = document.createElement("div");
        this.div.style.position = "absolute";
        this.div.classList.add("c-dealer-overlay__wrapper");
        this.div.appendChild(content);

        // Popup.preventMapHitsAndGesturesFrom(this.div);
      }
      onAdd() {
        this.getPanes().floatPane.appendChild(this.div);
      }
      onRemove() {
        if (this.div.parentElement) {
          this.div.parentElement.removeChild(this.div);
        }
      }
      hide() {
        if (this.div) {
          this.div.style.visibility = "hidden";
        }
      }
      updatePosition(options) {
        console.log("options", options);
        if (this.div) {
          this.div.style.left = options.x + "px";
          this.div.style.top = options.y + "px";
        }
      }
      show() {
        if (this.div) {
          this.div.style.visibility = "visible";
        }
      }
      draw() {
        const overlayProjection = this.getProjection();
        const sw = overlayProjection.fromLatLngToDivPixel(this.position);

        // Resize the image's div to fit the indicated dimensions.
        if (this.div) {
          this.div.style.left = sw.x + "px";
          this.div.style.top = sw.y + "px";
        }
      }
      toggleDOM(map) {
        if (this.getMap()) {
          this.setMap(null);
        } else {
          this.setMap(map);
        }
      }
    }
    return new Popup(position, content);
  };
  const onItemClick = (e, index) => {
    const item = result[index];
    if (visibleOverlay) {
      visibleOverlay.hide();
    }
    setActiveIndex(index);
    map.setCenter(new maps.LatLng(item.latitude, item.longitude));
    visibleOverlay = item.overlay;
    // item.overlay.show();
  };
  const toggleItem = useCallback(
    (e, index, data) => {
      const item = data[index];
      if(!item) {return false}
      setResult(result.slice(0));
      setActiveIndex(index);
      map.setCenter(new maps.LatLng(item.latitude, item.longitude));
      if (visibleOverlay) {
        visibleOverlay.hide();
      }
      visibleOverlay = item.overlay;
      item.overlay.show();
      gtag('event', 'Component_info', {
        'component_name': 'DealerSearch',
        'page_title': page?.name
      });
    },
    [result]
  );
  const clearMap = () => {
    result &&
      result.forEach(item => {
        if (item.marker) {
          item.marker.setMap(null);
        }
        if (item.overlay) {
          item.overlay.setMap(null);
        }
      });
    setResult([]);
    if (currentPos) {
      map.setCenter(new maps.LatLng(currentPos.latitude, currentPos.longitude));
    }
  };
  const touchStart = (e) => {
    setStartX(e.touches[0].pageX)
  }
  const touchEnd = (e) => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let endX = e.changedTouches[0].pageX
    if(endX - startX < -50) { //切换到下一个
      if(isAR) {
        if(count > 0) {
          setCount(count - 1)
        } else {
          setCount(0)
        }
      } else {
        if(count < result.length - 1) {
          setCount(count + 1)
        } else {
          setCount(result.length - 1)
        }
      }
    } else if(endX - startX > 50) { //切换到上一个
      if(isAR) {
        if(count < result.length - 1) {
          setCount(count + 1)
        } else {
          setCount(result.length - 1)
        }
      } else {
        if(count > 0) {
          setCount(count - 1)
        } else {
          setCount(0)
        }
      }
    }
  }
  useEffect((e) => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    if(swiperEl && swiperEl.current) {
      if(isAR) {
        swiperEl.current.style.transform = 'translateX(' + (pageWidth - 80 + 40 + 12) * count * 1 + 'px)'
      } else {
        swiperEl.current.style.transform = 'translateX(' + (pageWidth - 80 + 40 + 12) * count * -1 + 'px)'
      }
    }
    if(map) {
      toggleItem(e, count, result)
    }
  }, [count]);

  const touchEndA = (e) => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    let endX = e.changedTouches[0].pageX
    if(endX - startX < -50) { //切换到下一个
      if(isAR) {
        if(allCount > 0) {
          setAllCount(allCount - 1)
        } else {
          setAllCount(0)
        }
      } else {
        if(allCount < allresult.length - 1) {
          setAllCount(allCount + 1)
        } else {
          setAllCount(allresult.length - 1)
        }
      }
    } else if(endX - startX > 50) { //切换到上一个
      if(isAR) {
        if(allCount < allresult.length - 1) {
          setAllCount(allCount + 1)
        } else {
          setAllCount(allresult.length - 1)
        }
      } else {
        if(allCount > 0) {
          setAllCount(allCount - 1)
        } else {
          setAllCount(0)
        }
      }
    }
  }
  useEffect((e) => {
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth
    if(allswiperEl && allswiperEl.current) {
      if(isAR) {
        allswiperEl.current.style.transform = 'translateX(' + (pageWidth - 80 + 40 + 12) * allCount * 1 + 'px)'
      } else {
        allswiperEl.current.style.transform = 'translateX(' + (pageWidth - 80 + 40 + 12) * allCount * -1 + 'px)'
      }
    }
    if(map) {
      toggleItem(e, allCount, allresult)
    }
  }, [allCount]);
  const getCountryCode = async (countrtList) => {
    const [res, ex] = await apiAsia.dealer.getCountryCode({});
		console.log(res.countryCode)
    if(countrtList && countrtList.length > 0) {
      countrtList.forEach((item, index) => {
        if(item.code === res.countryCode && currentPos) {
          setCountrySelected(item)
          getCities(countrtList[index])
        }
      })

      if(!countrySelected) {
        setUnSelected(true)
        search()
      }
    }
  }
  useEffect(() => {
		init()
    loadGMap(lang).then(maps => {
      maps && initComponent(maps).catch();
    });
  }, []);
  const countryProps = {
    placeholder: country_label.value,
    options: countryOptions,
    selectedOption: countrySelected,
    warningMessage: countryError?.value,
    showError: countryShowError,
    async onChange(option) {
      setUnSelected(false)
      setCountryShowError(false)
      if (option.code !== countrySelected?.code) {
        setCountrySelected(option);
        setCityOptions([]);
        setCitySelected(null);
        clearMap();
        await getCities(option);
      }
    }
  };
  const clickCity = () => {
    gtag('event', 'Component_info', {
      'component_name': 'DealerSearch',
      'page_title': page?.name
    });
    if(!countrySelected) {
      setCountryShowError(true)
    }
  }
  const cityProps = {
    placeholder: city_label.value,
    options: cityOptions,
    selectedOption: citySelected,
    warningMessage: cityError,
    async onChange(option) {
      setCitySelected(option);
      clearMap();
      await search(countrySelected, option, driveType);
    }
  };
  let saleOptions = [];
  let _item = {
    code: null,
    value: null
  }
  sales_type.forEach((item) => {
    item.code = item?.fields?.key?.value;
    item.value = item?.fields?.text?.value;
    saleOptions.push(item);
  })
  const salesProps = {
    placeholder: sale_label.value,
    options: saleOptions,
    selectCode: saleOptions[0]?.code,
    selectedOption: saleOptions[0], // 默认选中第一项 All 所有销售类型
    async onChange(option) {
      // 切换销售类型
      setDriveType(option)
      await search(countrySelected, citySelected, option);
    }
  };

  const goThere = (e, item) => {
    const href = 'https://www.google.com/maps/dir/?api=1&origin=' + currentPos.latitude + ',' + currentPos.longitude + '&destination=' + item.latitude + ',' + item.longitude;
    let a = document.createElement('a')
    a.setAttribute('target', '_blank')
    a.setAttribute('href', href)
    document.body.appendChild(a)
    a.click()
  }
  const clickStop = (e) => {
    e.stopPropagation()
  }
  const rootStyle = getOverallSettingsStyles(fields);
  const rootClasses = classNames("c-dealer-search grid", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} style={rootStyle}>
      <div className="c-dealer-search__main">
        <div className="c-dealer-search__content">
          <div className="drop-content">
            <Heading html={title} type={{ fields: { phrase: { value: "h1" } } }} className="title" />
            <div className="area-content">
              <FilterDelarDropdown {...countryProps} />
              <div className="line" />
              <div className="city-content" onClick={clickCity}>
                <DelarDropdown {...cityProps} />
              </div>
            </div>
            <div className="line" />
            <div className="sales-drop-content"><DelarDropdown {...salesProps} /></div>
            {/* pc经销商列表 */}
            <div className="c-dealer-search__content-side">
              <>
                {result && result.length > 0 && (<div className="c-dealer-search__result-list">
                  {!unSelected && <BodyText className="c-dealer-search__result-title" tagName="div" html={{ value: resultTitle }} />}
                  <div className="c-dealer-search__result-list-wrapper">
                    {result.map((item, index) => (
                      <div className={classNames("c-dealer-search__item", { hight: activeIndex === index })} key={index} ref={e => resultRef.current.push(e)} onClick={e => toggleItem(e, index, result)}>
                        <div className="c-dealer-search__item-top">
                          <div className="c-dealer-search__item-name">{item.name}</div>
                          {item.driveStatus === 1 && <div className="new">{new_text?.value}</div>}
                          {item.driveStatus === 2 && <div className="soon">{comeing_soon_text?.value}</div>}
                        </div>
                        <div className="c-dealer-search__address-content">
                          {item.address && <div className="address">{item.address}</div>}
                          {getPosition && <div className="distance">{item.distance}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>)}

                {result.length < 1 && showEmpty && <div className="c-dealer-search__pc-empty-result-title-content">
                  <BackgroundImage {...empty_image} className="c-dealer-search__pc-empty-image" />
                  <RichText tag="div" className="c-dealer-search__pc-empty-result-title" field={result_empty_text} />
                </div>}

                {result.length < 1 && showEmpty && allresult && allresult.length > 0 && (<div className="c-dealer-search__result-list">
                  <div className="c-dealer-search__result-list-wrapper active">
                    {allresult.map((item, index) => (
                      <div className={classNames("c-dealer-search__item", { hight: activeIndex === index })} key={index} ref={e => resultRef.current.push(e)} onClick={e => toggleItem(e, index, allresult)}>
                        <div className="c-dealer-search__item-top">
                          <div className="c-dealer-search__item-name">{item.name}</div>
                          {item.driveStatus === 1 && <div className="new">{new_text?.value}</div>}
                          {item.driveStatus === 2 && <div className="soon">{comeing_soon_text?.value}</div>}
                        </div>
                        <div className="c-dealer-search__address-content">
                          {item.address && <div className="address">{item.address}</div>}
                          {getPosition && <div className="distance">{item.distance}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>)}
              </>
            </div>
          </div>
          <div className="c-dealer-search__content-map">
            <div className="c-dealer-search__map" ref={mapNode} />
            <div className="c-dealer-search__map-triggers">
              <div className="c-dealer-search__map-plus" />
              <div className="c-dealer-search__map-minus" />
            </div>
          </div>
          {/* m经销商列表 */}
          {result && result.length > 0 && <div className="c-dealer-search__swiper-content">
            {!unSelected && <BodyText className="c-dealer-search__result-title" tagName="div" html={{ value: resultTitle }} />}
            <div className="swiper" onTouchStart={touchStart} onTouchEnd={touchEnd}>
              <div className="swiper-wrapper">
                <div className="swiper-wrapper-con" ref={swiperEl}>
                  {isMobile && result && result.length > 0 && result.map((item, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="slide-name-distance">
                        <div className="slide-top">
                          <div className="slide-name">
                            {item.name}
                            {item.driveStatus === 1 && <div className="new">{new_text?.value}</div>}
                            {item.driveStatus === 2 && <div className="soon">{comeing_soon_text?.value}</div>}
                          </div>
                        </div>
                        {getPosition && <div className="slide-address-content">
                          <div className="slide-distance" onClick={(e) => goThere(e, item)}>
                            <Icon name="Navigation" />
                            <span className="distance">{item.distance}</span>
                          </div>
                        </div>}
                      </div>
                      {item.telephone && <div className="slide-overlay__info">
                        <Icon name="Telephone" />
                        <span className="tel">{item.telephone}</span>
                      </div>}
                      {item.address && <div className="slide-overlay__info">
                        <Icon name="Address" />
                        <span className="tel">{item.address}</span>
                      </div>}
                      {(test_drive_link?.value?.href || item.buyUrl) && <div className="slide-overlay__actions">
                        {test_drive_link?.value?.href && item.driveType !== 1 && <PrimaryButton {...{
                          colorScheme: {
                            fields: {
                              phrase: {
                                value: "green"
                              }
                            }
                          },
                          iconDef: "Right",
                          buttonText: test_drive_text?.value,
                          callback: () => {
                            let a = document.createElement('a')
                            a.setAttribute('target', '_blank')
                            a.setAttribute('href', test_drive_link?.value?.href + "?countryCode=" + item?.countryCode + '&delaerCode=' + item?.id)
                            document.body.appendChild(a)
                            a.click()
                          }
                        }} />}
                        {item.buyUrl && <PrimaryButton {...{
                          colorScheme: {
                            fields: {
                              phrase: {
                                value: "outline-green"
                              }
                            }
                          },
                          iconDef: "Right",
                          buttonText: buy_text?.value,
                          callback: () => {
                            let a = document.createElement('a')
                            a.setAttribute('target', '_blank')
                            a.setAttribute('href', item.buyUrl)
                            document.body.appendChild(a)
                            a.click()
                          }
                        }} />}
                      </div>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>}

          {result.length < 1 && showEmpty && getPosition && !unSelected && <div className="c-dealer-search__m-empty-result-title-content" onClick={(e) =>clickStop(e)}>
            <RichText tag="div" className="c-dealer-search__m-empty-result-title" field={result_empty_text} />
          </div>}
          
          {result.length < 1 && showEmpty && allresult && allresult.length > 0 && <div className="c-dealer-search__swiper-content active">
            <div className="swiper" onTouchStart={touchStart} onTouchEnd={touchEndA}>
              <div className="swiper-wrapper">
                <div className="swiper-wrapper-con" ref={allswiperEl}>
                  {isMobile && allresult && allresult.length > 0 && allresult.map((item, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="slide-name-distance">
                        <div className="slide-top">
                          <div className="slide-name">
                            {item.name}
                            {item.driveStatus === 1 && <div className="new">{new_text?.value}</div>}
                            {item.driveStatus === 2 && <div className="soon">{comeing_soon_text?.value}</div>}
                          </div>
                        </div>
                        {getPosition && !unSelected && <div className="slide-address-content">
                          <div className="slide-distance" onClick={(e) => goThere(e, item)}>
                            <Icon name="Navigation" />
                            <span className="distance">{item.distance}</span>
                          </div>
                        </div>}
                      </div>
                      {item.telephone && <div className="slide-overlay__info">
                        <Icon name="Telephone" />
                        <span className="tel">{item.telephone}</span>
                      </div>}
                      {item.address && <div className="slide-overlay__info">
                        <Icon name="Address" />
                        <span className="tel">{item.address}</span>
                      </div>}
                      {(test_drive_link?.value?.href || item.buyUrl) && <div className="slide-overlay__actions">
                        {test_drive_link?.value?.href && item.driveType !== 1 && item.driveType !== 1 && <PrimaryButton {...{
                          colorScheme: {
                            fields: {
                              phrase: {
                                value: "green"
                              }
                            }
                          },
                          iconDef: "Right",
                          buttonText: test_drive_text?.value,
                          callback: () => {
                            let a = document.createElement('a')
                            a.setAttribute('target', '_blank')
                            a.setAttribute('href', test_drive_link?.value?.href + "?countryCode=" + item?.countryCode + '&delaerCode=' + item?.id)
                            document.body.appendChild(a)
                            a.click()
                          }
                        }} />}
                        {item.buyUrl && <PrimaryButton {...{
                          colorScheme: {
                            fields: {
                              phrase: {
                                value: "outline-green"
                              }
                            }
                          },
                          iconDef: "Right",
                          buttonText: buy_text?.value,
                          callback: () => {
                            let a = document.createElement('a')
                            a.setAttribute('target', '_blank')
                            a.setAttribute('href', item.buyUrl)
                            document.body.appendChild(a)
                            a.click()
                          }
                        }} />}
                      </div>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    </div>
  );
};
const DealerOverlay = ({ item, go_text, test_drive_link, delaer, test_drive_text, buy_text }) => {
  const testDriveProps = {
    colorScheme: {
      fields: {
        phrase: {
          value: "green"
        }
      }
    },
    iconDef: "Right",
    buttonText: test_drive_text?.value,
    callback: () => {
      let a = document.createElement('a')
      a.setAttribute('target', '_blank')
      a.setAttribute('href', test_drive_link?.value?.href + "?countryCode=" + item?.countryCode + '&delaerCode=' + item?.id)
      document.body.appendChild(a)
      a.click()
    }
  };
  const contactUsProps = {
    colorScheme: {
      fields: {
        phrase: {
          value: "outline-green"
        }
      }
    },
    iconDef: "Right",
    buttonText: buy_text?.value,
    callback: () => {
      let a = document.createElement('a')
      a.setAttribute('target', '_blank')
      a.setAttribute('href', item.buyUrl)
      document.body.appendChild(a)
      a.click()
    }
  };
  const href = 'https://www.google.com/maps/dir/?api=1&origin=' + currentPos.latitude + ',' + currentPos.longitude + '&destination=' + item.latitude + ',' + item.longitude;
  const goThere = () => {
    let a = document.createElement('a')
    a.setAttribute('target', '_blank')
    a.setAttribute('href', href)
    document.body.appendChild(a)
    a.click()
  }
  return (
    <div className="c-dealer-overlay">
      <div className="c-dealer-overlay__header">
        <div className="c-dealer-overlay__title">{item.name}</div>
        <div className="c-dealer-overlay__navigation" onClick={goThere}>
          <Icon name="Navigation" />
          <span className="navigation_text">{go_text?.value}</span>
        </div>
      </div>
      {item.telephone && <div className="c-dealer-overlay__info">
        <Icon name="Telephone" />
        <span className="tel">{item.telephone}</span>
      </div>}
      {item.address && <div className="c-dealer-overlay__info">
        <Icon name="Address" />
        <span>{item.address}</span>
      </div>}
      {(test_drive_link?.value?.href || item.buyUrl) && <div className="c-dealer-overlay__actions">
        {test_drive_link?.value?.href && item.driveType !== 1 && <PrimaryButton {...testDriveProps} />}
        {item.buyUrl && <PrimaryButton {...contactUsProps} />}
      </div>}
    </div>
  );
};
const Animate = () => {
  return (<div className="animate-content">
    <div className="animate-out"></div>
    <div className="animate-in"></div>
  </div>)
}
export default DealerSearch;
